import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import {
  asignarEntCarDocentesAction,
  deleteEntCarDocentesAction,
} from '../../../../entidad/ent_carreras/EntCarrerasAction';
import SelectFieldEntCarrerasComponent from '../../../../entidad/ent_carreras/components/SelectFieldEntCarreras';

const EntCarrerasDocentesComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const carreras = docentesStore.activo.carreras;

  const [idEntCarrera, setIdEntCarrera] = React.useState('');
  const [loadingDelete, setLoadingDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <LoadingWidget
        isLoading={docentesStore.loadingAll || loadingDelete}
        text={
          loadingDelete ? 'Eliminando asignación...' : 'Asignando carrera...'
        }
      />

      <Grid item md={8}>
        <SelectFieldEntCarrerasComponent
          value={idEntCarrera}
          onChange={(id) => setIdEntCarrera(id)}
          selects={carreras}
        />
      </Grid>

      <Grid item md={3} sx={{ display: 'flex' }}>
        <BotonComponent
          click={async () => {
            const res = await asignarEntCarDocentesAction(
              { dispatch, notify },
              {
                idEntCarrera,
                idDocente: docentesStore.activo.id,
              },
            );
            if (res) setIdEntCarrera('');
          }}
          text="ASIGNAR"
          disabled={!idEntCarrera}
          addIcon
          green
          mr={2}
        />
      </Grid>

      <Grid item md={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="h5" color="initial">
          Asignados
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="carreras">
            <TableHead>
              <TableRow>
                {loginStore.isRoot ? <TableCell>ID</TableCell> : null}
                <TableCell>Carrera</TableCell>
                <TableCell>Modalidad</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Acción</TableCell>
              </TableRow>
            </TableHead>
            {carreras ? (
              <TableBody>
                {carreras.map((el) => (
                  <TableRow
                    key={el.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {loginStore.isRoot ? <TableCell>{el.id}</TableCell> : null}
                    <TableCell>{el.carrera.carrera.nombre}</TableCell>
                    <TableCell>{el.carrera.modalidad}</TableCell>
                    <TableCell>{el.carrera.carrera.desc}</TableCell>
                    <TableCell>
                      <Tooltip
                        describeChild
                        title="Eliminar la carrera"
                        placement="top"
                      >
                        <IconButton
                          color="error"
                          size="small"
                          aria-label="Eliminar carrera"
                          onClick={async () => {
                            setLoadingDelete(true);
                            await deleteEntCarDocentesAction(
                              { dispatch, notify },
                              el.id,
                              docentesStore.activo.id,
                            );
                            setLoadingDelete(false);
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : null}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default EntCarrerasDocentesComponent;
